import { AppBar, Box, Toolbar } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs } from '../../contexts/Breadcrumbs';
import { usePrerequisites } from '../../contexts/Prerequisites';
import connectassurePng from '../../styles/img/connectassure.png';
import AsyncAutocomplete from '../common/AsyncAutocomplete';

const ExternalLayout = ({ children }) => {
	const location = useLocation();
	const theme = useTheme();
	const [, { setLanguage }] = usePrerequisites();
	const { languages = [], language } = useSelector((state) => ({ languages: [{ id: 'en', label: 'English' }], ...state.i18n }));
	const isLanguageActive = languages.some(lang => lang.id === language);
	const languageId = languages.length && languages[0].id || '';

	useEffect(() => {
		if (!isLanguageActive) {
			setLanguage(languageId);
		}
	}, [isLanguageActive, languageId]);

	const handleOnChangeLanguage = useCallback(
		(e, newValue) => {
			setLanguage(newValue?.id || language);
		},
		[language]
	);

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position="static" elevation={0} sx={{ backgroundColor: '#3c85d0' }}>
				<Toolbar>
					{location.pathname?.toLowerCase?.() === '/setup' && (
						<Box>
							<Box
								sx={{ height: theme.spacing(5) }}
								component="img"
								src={connectassurePng}
								alt="connectassure"
							/>
						</Box>
					)}
					<Box sx={{ flexGrow: 1 }} />
					<AsyncAutocomplete
						value={isLanguageActive ? language : languageId}
						onChange={handleOnChangeLanguage}
						options={languages}
						margin="dense"
						size="small"
						disableClearable
						sx={{
							minWidth: 240,
							'& .MuiInputBase-root': {
								color: theme.palette.background.paper,
								backgroundColor: alpha(theme.palette.background.paper, 0.05),
								'& .MuiIconButton-root': {
									color: theme.palette.primary.contrastText
								},
								'&:hover': {
									backgroundColor: alpha(theme.palette.background.paper, 0.15)
								},
								'&:focus': {
									backgroundColor: alpha(theme.palette.background.paper, 0.15)
								}
							},
							'& .MuiOutlinedInput-notchedOutline': {
								color: theme.palette.primary.contrastText,
								border: 0,
								'&:hover': {
									border: 0,
									backgroundColor: alpha(theme.palette.background.paper, 0.15)
								},
								'&:focus': {
									border: 0,
									backgroundColor: alpha(theme.palette.background.paper, 0.15)
								}
							}
						}}
					/>
				</Toolbar>
			</AppBar>
			<Box component={'main'} sx={{ padding: theme.spacing(2, 2) }}>
				{location.pathname?.toLowerCase?.() === '/setup' && <Breadcrumbs />}
				{children}
			</Box>
		</Box>
	);
};

export default memo(ExternalLayout);